import { reactive } from 'vue'

const toast = reactive({ text: '', show: false })
let timer = null

export function useGuideToast() {
  const showToast = (text) => {
    toast.text = text
    toast.show = true
    window.clearTimeout(timer)
    timer = window.setTimeout(() => { toast.show = false }, 2200)
  }

  const copyLink = async (url) => {
    try {
      await navigator.clipboard.writeText(url)
      showToast('Link copied')
    } catch (error) {
      showToast('Couldn’t copy — long-press the link instead')
    }
  }

  return { toast, showToast, copyLink }
}
